import { ConsentContainer } from '../../_containers';

export default function CaptureFaceConsentPage() {
  return (
    <ConsentContainer
      consentContentUrl='/consent/face-consent-{locale}.md'
      nextStep='capture-face-instruction'
    />
  );
}
